const getServiceWorkerContainer = () => (
    typeof navigator !== "undefined" ? navigator.serviceWorker : undefined
);

const getCacheStorage = () => (
    typeof window !== "undefined" ? window.caches : undefined
);

const runCleanupTask = async (task) => {
    try {
        await task();
    } catch (error) {
        console.warn("重新啟動時無法清除部分 PWA 快取：", error);
    }
};

// 移除目前頁面使用的 service worker 與 Cache Storage，避免 PWA 重整後仍取得舊版資源。
export async function clearCachedAppAssets({
    serviceWorkerContainer = getServiceWorkerContainer(),
    cacheStorage = getCacheStorage(),
} = {}) {
    const cleanupTasks = [];

    if (typeof serviceWorkerContainer?.getRegistration === "function") {
        cleanupTasks.push(
            async () => {
                const registration = await serviceWorkerContainer.getRegistration();
                if (registration) await registration.unregister();
            }
        );
    }

    if (typeof cacheStorage?.keys === "function" && typeof cacheStorage?.delete === "function") {
        cleanupTasks.push(
            async () => {
                const cacheNames = await cacheStorage.keys();
                await Promise.all(
                    cacheNames.map((cacheName) => (
                        runCleanupTask(() => cacheStorage.delete(cacheName))
                    ))
                );
            }
        );
    }

    await Promise.all(cleanupTasks.map((task) => runCleanupTask(task)));
}

export async function restartApplication() {
    await clearCachedAppAssets();

    // 導覽至帶有唯一參數的同一頁，略過瀏覽器的入口頁快取；新版入口會載入新版 hash JS/CSS。
    const restartUrl = new URL(window.location.href);
    restartUrl.searchParams.set("_restart", Date.now().toString());
    window.location.replace(restartUrl.toString());
}
